(function () {
    'use strict';

    angular.module('app').constant('PAGES', {
        MARKET_INFO: {
            PERMISSION_DENIED: 'app/security/permission-denied.html'
        }
    });
})();
